import React, { useCallback, useEffect, useState } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TruthSection } from './components/TruthSection';
import { ImpactSection } from './components/ImpactSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ReviewsSection } from './components/ReviewsSection';
import { FinalCTA } from './components/FinalCTA';
import { OrderBump } from './components/OrderBump';
import { ClosingSection } from './components/ClosingSection';
import { BonusSection } from './components/BonusSection';
import { ValueSection } from './components/ValueSection';
import { PriceAnchor } from './components/PriceAnchor';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  const [addedBumps, setAddedBumps] = useState<Record<string, boolean>>({});
  useEffect(() => {
    initMetaPixel();
  }, []);
  const toggleBump = useCallback((id: string) => {
    setAddedBumps(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  }, []);
  return <div className="w-full min-h-screen bg-dark-bg" data-id="element-0">
      <Header addedBumps={addedBumps} data-id="element-1" />
      <main data-id="element-2">
        <HeroSection addedBumps={addedBumps} data-id="element-3" />
        <PainSection data-id="element-4" />
        <TruthSection data-id="element-5" />
        <ImpactSection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <ValueSection data-id="element-9" />
        <BenefitsSection data-id="element-10" />
        <ReviewsSection data-id="element-11" />
        <PriceAnchor data-id="element-12" />
        <FinalCTA addedBumps={addedBumps} data-id="element-13" />
        <OrderBump addedBumps={addedBumps} toggleBump={toggleBump} data-id="element-14" />
        <ClosingSection addedBumps={addedBumps} data-id="element-15" />
      </main>
    </div>;
}